module.exports = __webpack_public_path__ + "static/media/country_us.68a79166.webp";